import React, { useState, useEffect } from 'react';
import { BsTelephoneFill, BsGeoAltFill } from 'react-icons/bs';
import logoMCF from '../assets/images/logo-mcf.png';
import './Avis.css';

const Avis = () => {
  const [reviews, setReviews] = useState([]);
  const [loading, setLoading] = useState(true);

  // Simuler le chargement des avis Google
  // Dans une vraie application, vous utiliseriez l'API Google Reviews
  useEffect(() => {
    // Simuler un délai de chargement
    setTimeout(() => {
      const mockReviews = [
        {
          id: 1,
          name: 'Aylan',
          avatarLetter: 'A',
          avatarColor: '#2C5530', // Vert foncé
          text: "Auto-École organiser avec un service rapide et sérieux, moniteur à l'écoute et bonne apprentissage des normes de conduite je recommande vivement Top Conduite 👍👌👌",
          rating: 5
        },
        {
          id: 2,
          name: 'Heshan Beragama',
          avatarLetter: 'H',
          avatarColor: '#8B4513', // Marron foncé
          text: "La meilleure auto-école à Mitry-Mory, les moniteurs sont expérimentés et à l'écoute. Je la recommande.",
          rating: 5
        },
        {
          id: 3,
          name: 'aml B',
          avatarLetter: 'a',
          avatarColor: '#9B59B6', // Violet
          text: "Excellente auto école que je recommande. Après avoir eu une mauvaise expérience avec une autre auto école je me suis retourner chez Top conduite car il y avais beaucoup de bon retours sur cette auto école j'ai fais confiance et je ne regrette vraiment pas. Un grand merci à Bilel qui m'a suivi avec bienveillance et qui a était très pédagogue dans sa manière d'apprendre.",
          rating: 5
        },
        {
          id: 4,
          name: 'Assia',
          avatarLetter: 'A',
          avatarColor: '#1ABC9C', // Turquoise/vert
          text: "Super auto école, avec de très bon moniteurs, ils sont patients et très pédagogues. Aucun soucis avec les heures ou les dates. J'ai pu avoir mon permis rapidement grâce à eux. La secrétaire est très accueillante, souriante et trouve toujours un moyen de nous arranger. Choisissez cette auto école sans hésiter !!!",
          rating: 5
        },
        {
          id: 5,
          name: 'Bilal Kd',
          avatarLetter: 'B',
          avatarColor: '#E74C3C', // Rouge
          text: "Excellente auto école ! Merci à Hichem et Bilel pour leur enseignement de qualité qui m'ont permis d'obtenir mon permis rapidement ! Je recommande vivement cette auto-école !",
          rating: 5
        },
        {
          id: 6,
          name: 'Amel ._',
          avatarLetter: 'A',
          avatarColor: '#FF6B35', // Orange (couleur du coucher de soleil)
          text: "Très bonne auto école ! On obtient une date pour le permis très rapidement, les moniteurs sont pédagogues, savent s'adapter aux difficultés de chaque élèves et mettent à l'aise, tout comme la secrétaire. Je la recommande vivement !",
          rating: 5
        }
      ];
      setReviews(mockReviews);
      setLoading(false);
    }, 500);
  }, []);

  return (
    <div className="avis-page">
      <section className="avis-hero">
        <div className="container">
          <div className="hero-content-avis">
            <h1 className="avis-title">Avis de Nos Élèves</h1>
            {!loading && (
              <div className="avis-stats">
                <div className="rating-display-large">
                  <span className="rating-number-large">4.7</span>
                  <span className="rating-stars-large">★★★★★</span>
                </div>
                <p className="rating-source-large">Basé sur 136 avis Google</p>
              </div>
            )}
          </div>
        </div>
      </section>

      <section className="avis-list">
        <div className="container">
          {loading ? (
            <div className="loading">Chargement des avis...</div>
          ) : (
            <div className="reviews-grid-full">
              {reviews.map((review) => (
                <div key={review.id} className="review-card-full">
                  <div className="review-header-full">
                    <div 
                      className="review-avatar-full"
                      style={{
                        backgroundColor: review.avatarColor,
                        color: 'white',
                        fontWeight: 'bold'
                      }}
                    >
                      {review.avatarLetter}
                    </div>
                    <div className="review-info">
                      <h3 className="review-name-full">{review.name}</h3>
                    </div>
                  </div>
                  <div className="review-rating">
                    {'★'.repeat(review.rating)}{'☆'.repeat(5 - review.rating)}
                  </div>
                  <p className="review-text-full">"{review.text}"</p>
                </div>
              ))}
            </div>
          )}

          <div style={{ textAlign: 'center', marginBottom: '40px' }}>
            <a 
              href="https://www.google.com/search?sa=X&sca_esv=4e4b8a2bf4a3d9a0&biw=1080&bih=1728&aic=0&sxsrf=ANbL-n7jnRco933X4mIoDezuTlyHpyL0PA:1768820995870&q=Top%20Conduite%20Avis&rflfq=1&num=20&stick=H4sIAAAAAAAAAONgkxIxNDczMrSwMDAyMzOxMDMxNTAxNdvAyPiKUTAkv0DBOT8vpTSzJFXBsSyzeBErphgA5DC8lUMAAAA&rldimm=17621880266486450456&tbm=lcl&hl=fr-FR&ved=0CEQQ5foLahcKEwj42rvZu5eSAxUAAAAAHQAAAAAQCg#lkt=LocalPoiReviews&arid=Ci9DQUlRQUNvZENodHljRjlvT2tkeVNUWXRjSEZIUTBFM2VYSjNUbWRYUWxGUFQyYxAB"
              target="_blank"
              rel="noopener noreferrer"
              className="btn btn-orange see-all-google-reviews"
            >
              Voir tous les avis Google
            </a>
          </div>

          <div className="contact-info-section">
            <h2 className="contact-info-title">Nous Contacter</h2>
            <div className="contact-info-items">
              <a href="tel:0952655019" className="contact-item-full">
                <BsTelephoneFill className="contact-icon-full" />
                <span>09 52 65 50 19</span>
              </a>
              <a href="https://maps.google.com/?q=19+Av.+Franklin+Roosevelt,+77290+Mitry-Mory" target="_blank" rel="noopener noreferrer" className="contact-item-full">
                <BsGeoAltFill className="contact-icon-full" />
                <span>19 Av. Franklin Roosevelt, 77290 Mitry-Mory</span>
              </a>
            </div>

            <div className="payment-info">
              <div className="payment-item">
                <div className="payment-3x-badge" aria-hidden="true">
                  <span className="payment-3x-value">3×</span>
                </div>
                <div className="payment-content">
                  <h3 className="payment-title">Paiement en 3 fois</h3>
                  <p className="payment-description">Sans frais</p>
                </div>
              </div>
              <div className="payment-item" style={{ display: 'none' }}>
                <div className="payment-logo-wrapper">
                  <img src={logoMCF} alt="Mon Compte Formation" className="payment-logo" />
                </div>
                <div className="payment-content">
                  <h3 className="payment-title">Financement CPF</h3>
                  <p className="payment-description">Possible</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Avis;
